import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-btn-circle',
  templateUrl: './ui-btn-circle.component.html',
  styleUrls: ['./ui-btn-circle.component.scss']
})
export class UiBtnCircleComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() btnStyle: string;
  @Input() type: 'plus' | 'minus' = 'plus';
  @Input() size: 'xl' | 'lg' | 'md' | 'sm' = 'lg';
  @Output() onClick = new EventEmitter<void>();

  constructor() {
  }

  ngOnInit() {
  }

}
